import { Section } from "@/components/layout/Layout";

// Shared header + body markup for a rendered Insight post — used by the
// real public detail page (InsightDetail) and the admin preview
// (PostPreview), so a preview can never visually drift from what actually
// gets published. Callers own their own top spacing (InsightDetail already
// has a "back to Insights" row above this; PostPreview starts fresh with
// its own pt-32) — this component only ever supplies pb-16 up top.
export default function InsightArticle({ post, topClassName = "pb-16" }) {
    return (
        <>
            <Section className={topClassName}>
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 lg:items-center">
                    {post.cover_image && (
                        <div className="lg:col-span-4 overflow-hidden rounded-3xl aspect-square bg-muted">
                            <img src={post.cover_image} alt={post.cover_image_alt || ""} className="w-full h-full object-cover" loading="lazy" />
                        </div>
                    )}
                    <div className={post.cover_image ? "lg:col-span-8" : "lg:col-span-12"}>
                        <p className="label">{post.category} · {post.read_minutes} min read</p>
                        <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl mt-6 tracking-tight leading-[0.98]">
                            {post.title}
                        </h1>
                        <p className="prose-body text-lg mt-10">{post.excerpt}</p>
                    </div>
                </div>
            </Section>

            <Section className="pb-32">
                {Array.isArray(post.body) ? (
                    <article className="max-w-3xl mx-auto space-y-10" data-testid="insight-body">
                        {post.body.map((b, i) => {
                            if (b.type === "h2")
                                return <h2 key={i} className="font-serif text-3xl sm:text-4xl tracking-tight mt-6">{b.text}</h2>;
                            if (b.type === "quote")
                                return (
                                    <blockquote key={i} className="font-serif italic text-2xl sm:text-3xl leading-snug border-l-2 border-foreground/40 pl-6">
                                        {b.text}
                                    </blockquote>
                                );
                            return <p key={i} className="prose-body text-lg">{b.text}</p>;
                        })}
                    </article>
                ) : (
                    <article
                        className="max-w-3xl mx-auto prose prose-lg dark:prose-invert prose-headings:font-serif prose-headings:tracking-tight prose-blockquote:font-serif prose-blockquote:italic"
                        data-testid="insight-body"
                        dangerouslySetInnerHTML={{ __html: post.body }}
                    />
                )}
            </Section>
        </>
    );
}
